/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_View_Diet_OfInputs */

const en_portal_view_diet_of = /** @type {(inputs: Portal_View_Diet_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`of 2400 kcal`)
};

const pl_portal_view_diet_of = /** @type {(inputs: Portal_View_Diet_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z 2400 kcal`)
};

/**
* | output |
* | --- |
* | "of 2400 kcal" |
*
* @param {Portal_View_Diet_OfInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_view_diet_of = /** @type {((inputs?: Portal_View_Diet_OfInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_View_Diet_OfInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_view_diet_of(inputs)
	return en_portal_view_diet_of(inputs)
});